module.exports = __webpack_public_path__ + "static/img/partner_01.99c005f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/partner_01.png
// module id = hDYy
// module chunks = 1